<template>
  <v-content>
    <section>
      <v-parallax v-bind:src="backgrounds[0]" height="600">
        <v-layout
          column
          align-center
          justify-center
          class="white--text"
        >
          <img src="static/img/logo.png" alt="Retec Software" height="200">
          <h1 class="white--text mb-2 display-1 text-xs-center">Retec Software</h1>
          <div class="subheading mb-3 text-xs-center">CUSTOM SOFTWARE DEVELOPMENT</div>
          <v-btn
            class="primary mt-5"
            large
            href="mailto:contact@retec.org"
          >
            Contact us
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center
      >
        <v-flex xs12 sm4 class="my-3">
          <div class="text-xs-center">
            <h2 class="headline">Everything is possible</h2>
            <span class="subheading">
              Turn your great ideas into software products with our software development services.
            </span>
          </div>
        </v-flex>
        <v-flex v-for="(targetRow, iRow) in targets" :key="iRow" xs12>
          <v-container grid-list-xl>
            <v-layout row wrap align-start>
              <v-flex v-for="(targetCol, iCol) in targetRow" :key="iCol" xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="primary--text text--lighten-2">{{ targetCol.icon }}</v-icon>
                  </v-card-text>
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">{{ targetCol.title }}</div>
                  </v-card-title>
                  <v-card-text>{{ targetCol.text }}</v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-parallax v-bind:src="backgrounds[1]" height="380">
        <v-layout class="primary--text" column align-center justify-center>
          <div class="headline mb-3 text-xs-center">Client-oriented approach</div>
          <em>Our mission is to help your business cutting-edge technologies and best practices in software development.</em>
          <v-btn
            class="primary mt-5"
            large
            href="mailto:contact@retec.org"
          >
            Contact us
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="my-5">
          <v-flex xs12 sm4>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Company info</div>
              </v-card-title>
              <v-card-text>
                Retec Software has been developing, designing, and creating mobile, desktop and web applications since 2007.
                Our diverse collective background includes engineers, designers, and technical experts in different
                areas, technologies, approaches. We are always focused at highly customized solutions to technical
                problems that further your business success.
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Contact us</div>
              </v-card-title>
              <v-card-text>
                Whether you are looking for a software business partner, a job, or if you just want to say hello, simply fill in the form on this page and we will get back to you shortly.
              </v-card-text>
              <v-list class="transparent">
                <!-- <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text text--lighten-2">place</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Saint-Petersburg, RU</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile> -->
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="primary--text text--lighten-2">email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>contact@retec.org</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </v-content>
</template>

<script>
export default {
  data () {
    return {
      backgrounds: [
        '/static/img/skyscraper.jpg',
        '/static/img/notecoffee.jpg'
      ],
      targets: [[{
        icon: 'desktop_mac',
        title: 'Web Application development',
        text: `We build powerful and scalable web apps that are custom made using agile development
              processes leveraging the latest web technologies.`
      }, {
        icon: 'phone_iphone',
        title: 'Mobile & Software development',
        text: `We will help you to focus on your core mission by leveraging our expertise and global
              delivery capabilities to manage your solution end to end, freeing you to shift IT cost
              from operations and drive value back to the business.`
      }, {
        icon: 'cloud_done',
        title: 'Infrastructure solutions',
        text: `We leverage our proven transition process to ensure a smooth start of systems support
              services to become operational while keeping critical components in mind and ensuring
              minimal impact to clients on all service levels.`
      }], [{
        icon: 'done_all',
        title: 'Full-cycle development',
        text: `Full Cycle Software Development offers solutions for all phases of the software
              development cycle. We bring a broad range of experience to the software development
              process and work across many platforms, including enterprise-wide, next generation
              technologies and Cloud.`
      }, {
        icon: 'build',
        title: 'Maintenance and support',
        text: `We will help you to focus on your core mission by leveraging our expertise and global
              delivery capabilities to manage your solution end to end, freeing you to shift IT cost
              from operations and drive value back to the business.`

      }, {
        icon: 'trending_up',
        title: 'Re-engineering legacy enterprise systems',
        text: `Upgrade your system for best results.
              A lot of legacy systems use older technologies, heritage that does not benefit
              from the efficiency leaps made by modern technologies. That means expensive
              maintenance, higher software and infrastructure support costs, problematic
              integration and scalability. Software reengineering can therefore have a huge impact.`

      }]]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue